/* eslint-disable */

/**
 * Google Analytics Module
 * Handles event logging to Google Analytics via dataLayer
 */

/**
 * Log event to Google Analytics
 */
export function logGoogleAnalyticsEvent(eventName, eventData, debug = false) {
  if (!window.dataLayer || !window.dataLayer.push) {
    if (debug) {
      console.info('[GA] dataLayer not found');
    }
    return;
  }

  window.dataLayer.push({
    event: eventName,
    eventCategory: eventName,
    eventValue: eventName,
    eventAction: eventName,
    eventLabel: eventName,
  });

  if (debug) {
    console.info(`[GA] Event: ${eventName}`);
  }
}
